import { render, staticRenderFns } from "./register.view.vue?vue&type=template&id=d18c44a6&scoped=true&"
import script from "./register.view.ts?vue&type=script&lang=ts&"
export * from "./register.view.ts?vue&type=script&lang=ts&"
import style0 from "./register.view.scss?vue&type=style&index=0&id=d18c44a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18c44a6",
  null
  
)

export default component.exports